import React, { ReactElement, useState } from "react";
import styled from "styled-components";

interface LoadingProgressIndicatorProps {
  addSubscriberToLoadingStatus: (
    name: string,
    cb: (pctLoaded: number) => void
  ) => void;
}

const ProgressBarWrapper = styled.div`
  position: absolute;
  width: 33%;
  top: 50%;
  left: calc(50% - 15%);
`;

const Blackbackground = styled.div.attrs((props) => ({
  display: props.hidden ? "none" : "block",
}))`
  display: ${(props) => props.display};
  position: absolute;
  background-color: black;
  width: 100%;
  height: 100%;
`;

function LoadingProgressIndicator(
  props: LoadingProgressIndicatorProps
): ReactElement<LoadingProgressIndicatorProps> {
  const { addSubscriberToLoadingStatus } = props;

  const [progressPct, setProgressPct] = useState(0);

  addSubscriberToLoadingStatus(
    "loadingProgressIndicator",
    (pctLoaded: number) => {
      if (progressPct !== pctLoaded) {
        setProgressPct(pctLoaded);
      }
    }
  );
  const progressBar =
    progressPct < 100 ? (
      <progress
        style={{ width: "100%" }}
        id="loading"
        value={progressPct}
        max="100"
      >
        {progressPct}%
      </progress>
    ) : null;
  return (
    <Blackbackground hidden={progressPct == 100}>
      <ProgressBarWrapper>{progressBar}</ProgressBarWrapper>
    </Blackbackground>
  );
}

export default LoadingProgressIndicator;
